import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IIcd10CodesStore, IThunkGetMoreIcd10Codes } from '../types';

const onGetMoreIcd10Codes: IThunkGetMoreIcd10Codes = thunk(
  // @ts-ignore
  async ({ setMoreIcd10Codes }, filters, { getState }) => {
    const localState = getState() as IIcd10CodesStore;
    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.icd10Codes.getList({
      ...filters,
      ...paginationPayload,
    });

    setMoreIcd10Codes(data);
  },
);

export default onGetMoreIcd10Codes;
